export const UPLOAD_MEDIA_TO_AWS_COMPLETED = "[add media to AWS action] add media to AWS completed"
export const UPLOAD_MEDIA_TO_AWS_FAILED = "[add media to AWS action] add media to AWS failed"

